import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { ICommand } from 'src/app/core/commands/base/command.interface'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { DdcLoggerService } from 'src/app/service/log/ddc-logger.service'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'

@Component({
  selector: 'ddc-button-s-one',
  templateUrl: './ddc-button-s-one.component.html',
  styleUrls: ['./ddc-button-s-one.component.scss'],
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcButtonSOneComponent {
  @Input() _label: string
  @Input() _isLoading: boolean
  @Input() _icon: string
  @Input() command?: ICommand
  @Input() disabled: boolean = false
  @Output() buttonClick: EventEmitter<void> = new EventEmitter<void>()

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false

  _haveIcon: boolean = false

  private themeSubscription: Subscription

  constructor(
    private logger: DdcLoggerService,
    public themeService: ThemeService,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
    })

    if (this._icon) this._haveIcon = true
  }

  onClick(): void {
    if (this.command) {
      this.command.execute().subscribe()
    } else {
      this.buttonClick.emit()
    }
  }

  ngOnDestroy(): void {
    this.themeSubscription.unsubscribe()
  }
}
